import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

export default function ForgotPasswordPage() {
  const { resetPassword } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [email, setEmail] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const result = await resetPassword(email);
      if (result.success) {
        setIsSuccess(true);
        toast.success('Email envoyé !');
      } else {
        toast.error(result.error || 'Erreur lors de l\'envoi');
      }
    } catch (error) {
      toast.error('Une erreur est survenue');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <main data-testid="forgot-password-page" className="min-h-screen pt-20 bg-warm-alabaster flex items-center justify-center py-16">
      <div className="w-full max-w-md px-6">
        <div className="bg-white p-8 border border-border-subtle">
          {/* Header */}
          <div className="text-center mb-8">
            <Link to="/" className="inline-block mb-6">
              <span className="font-serif text-2xl font-semibold text-espresso">
                Léger's <span className="text-latte-gold">Coffee</span>
              </span>
            </Link>
            <h1 className="font-serif text-2xl text-espresso font-semibold mb-2">
              Mot de Passe Oublié
            </h1>
            <p className="text-soft-charcoal-secondary text-sm">
              Entrez votre email pour réinitialiser votre mot de passe
            </p>
          </div>

          {isSuccess ? (
            /* Success Message */
            <div className="text-center py-8">
              <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-green-100 flex items-center justify-center">
                <Mail className="w-8 h-8 text-green-600" />
              </div>
              <h2 className="font-serif text-xl text-espresso font-semibold mb-2">
                Email Envoyé !
              </h2>
              <p className="text-soft-charcoal-secondary text-sm mb-6">
                Consultez votre boîte mail pour réinitialiser votre mot de passe.
              </p>
              <Link
                to="/connexion"
                className="inline-flex items-center text-espresso font-medium hover:text-latte-gold transition-colors duration-300"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                Retour à la connexion
              </Link>
            </div>
          ) : (
            /* Form */
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="input-field"
                  placeholder="votre@email.com"
                  data-testid="forgot-email"
                />
              </div>

              <Button
                type="submit"
                disabled={isLoading}
                className="w-full btn-primary"
                data-testid="forgot-submit"
              >
                {isLoading ? 'Envoi...' : 'Envoyer le lien'}
              </Button>

              <Link
                to="/connexion"
                className="flex items-center justify-center text-soft-charcoal-secondary hover:text-espresso transition-colors duration-300"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                Retour à la connexion
              </Link>
            </form>
          )}
        </div>
      </div>
    </main>
  );
}
